const Buttons=(props)=>{
    return(
        <div className="bungalowbtn">
        <button className="btn" type="button" > {props.Button} </button>
    </div>
       
)
}
    export default Buttons;